import { AccelFile } from "@axl/membership-sdk";

export type FileProviderFile = {
  previewImage?: string;
  previewAudio?: string;
  isExternalFile?: boolean;
  url?: string;
  cloudKey: string;
  id?: string;
  /** false = S3 ACL private (a video in a task answer): no anonymous CDN link, only the signed download */
  isPublic?: boolean;
};

type FileProviderConfig = {
  cloudFront: string;
  videoCloudFront: string;
  origin: string;
};

export class FileProvider {
  // eslint-disable-next-line no-empty-function
  constructor(private config: FileProviderConfig) { }

  public getUrl(file: FileProviderFile, usePreview = false) {
    if (!file) return undefined;
    if (usePreview === true && file.previewImage) return file.previewImage;
    if (usePreview === true && file.previewAudio) return file.previewAudio;
    if (file.isExternalFile) return file.url;

    return this.getUrlByKey(file.cloudKey);
  }

  public getDownloadUrl(file: Pick<AccelFile, 'id' | 'url' | 'isExternalFile'>, isPreview = false) {
    if (file.isExternalFile) return file.url!;
    // important to use same origin to prevent CORS issues (ios safari)
    const url = new URL(this.config.origin + '/file/download/' + file.id);
    url.searchParams.set('isPreview', isPreview.toString());
    return url.toString();
  }

  public getVideoUrl(file: FileProviderFile) {
    if (!file) return undefined;
    if (file.isExternalFile) return file.url;
    // a private file answers 403 on the CDN; /file/download/{id} redirects to a signed S3 link (6 h) the player can stream
    if (file.isPublic === false && file.id && file.cloudKey && !file.cloudKey.startsWith("http"))
      return this.getDownloadUrl({ id: file.id, url: undefined, isExternalFile: false }, true);

    return this.getVideoUrlByKey(file.cloudKey);
  }

  public getUrlByKey(cloudKey: string) {
    if (!cloudKey) return undefined;

    return `${this.config.cloudFront}/${cloudKey}`;
  }

  public getVideoUrlByKey(cloudKey: string) {
    if (!cloudKey) return undefined;
    if (cloudKey.startsWith("http")) return cloudKey;

    return `${this.config.videoCloudFront}/${cloudKey}`;
  }
}
